const Footer = () => {
  return (
    <div className="footer bg-cyan-900 text-violet-50 text-center py-10">
      <p>
        Copyright © ;{new Date().getFullYear()} easy Tech. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
